// Category image imports - using unique images for each category
import constructionImg from "@/assets/categories/construction.jpg";
import automotiveImg from "@/assets/categories/automotive.jpg";
import ictImg from "@/assets/categories/ict.jpg";
import creativeImg from "@/assets/categories/creative.jpg";
import domesticImg from "@/assets/categories/domestic.jpg";
import healthImg from "@/assets/categories/health.jpg";
import educationImg from "@/assets/categories/education.jpg";
import agricultureImg from "@/assets/categories/agriculture.jpg";
import logisticsImg from "@/assets/categories/logistics.jpg";
import legalImg from "@/assets/categories/legal.jpg";
import handymanImg from "@/assets/categories/handyman.jpg";
import applianceImg from "@/assets/categories/appliance.jpg";
import securityImg from "@/assets/categories/security.jpg";
import tailoringImg from "@/assets/categories/tailoring.jpg";
import eventsImg from "@/assets/categories/events.jpg";
import realEstateImg from "@/assets/categories/real-estate.jpg";
import manufacturingImg from "@/assets/categories/manufacturing.jpg";
import energyOilGasImg from "@/assets/categories/energy-oil-gas.jpg";
import marineShippingImg from "@/assets/categories/marine-shipping.jpg";
import aviationAerospaceImg from "@/assets/categories/aviation-aerospace.jpg";
import miningQuarryImg from "@/assets/categories/mining-quarry.jpg";
import environmentalImg from "@/assets/categories/environmental.jpg";
import hospitalityTourismImg from "@/assets/categories/hospitality-tourism.jpg";
import retailSalesImg from "@/assets/categories/retail-sales.jpg";
import consultingBusinessImg from "@/assets/categories/consulting-business.jpg";
import translationLanguageImg from "@/assets/categories/translation-language.jpg";
import writingContentImg from "@/assets/categories/writing-content.jpg";
import sportsRecreationImg from "@/assets/categories/sports-recreation.jpg";
import publicSafetyImg from "@/assets/categories/public-safety.jpg";
import veterinaryPetImg from "@/assets/categories/veterinary-pet.jpg";
import heavyEquipmentImg from "@/assets/categories/heavy-equipment.jpg";
import inspectionTestingImg from "@/assets/categories/inspection-testing.jpg";
import surfaceTreatmentImg from "@/assets/categories/surface-treatment.jpg";

// Fallback placeholder for categories without images
const placeholderImg = "/placeholder.svg";

// Map each category to a unique image - NO DUPLICATES
export const categoryImages: Record<string, string> = {
  // Primary categories with dedicated images
  construction: constructionImg,
  automotive: automotiveImg,
  ict: ictImg,
  creative: creativeImg,
  domestic: domesticImg,
  health: healthImg,
  education: educationImg,
  agriculture: agricultureImg,
  logistics: logisticsImg,
  "legal-finance": legalImg,
  
  // Now with unique images
  handyman: handymanImg,
  "appliance-repair": applianceImg,
  tailoring: tailoringImg,
  security: securityImg,
  "events-hospitality": eventsImg,

  // International trade categories
  "real-estate": realEstateImg,
  manufacturing: manufacturingImg,
  "energy-oil-gas": energyOilGasImg,
  "marine-shipping": marineShippingImg,
  "aviation-aerospace": aviationAerospaceImg,
  "mining-quarry": miningQuarryImg,
  environmental: environmentalImg,
  "hospitality-tourism": hospitalityTourismImg,
  "retail-sales": retailSalesImg,
  "consulting-business": consultingBusinessImg,
  "translation-language": translationLanguageImg,
  "writing-content": writingContentImg,
  "sports-recreation": sportsRecreationImg,
  "public-safety": publicSafetyImg,
  "veterinary-pet": veterinaryPetImg,
  "heavy-equipment": heavyEquipmentImg,
  "inspection-testing": inspectionTestingImg,
  "surface-treatment": surfaceTreatmentImg,
};

// Helper to get image with fallback
export const getCategoryImage = (categoryId: string): string => {
  return categoryImages[categoryId] || placeholderImg;
};

export { 
  constructionImg, 
  automotiveImg, 
  ictImg, 
  creativeImg, 
  domesticImg, 
  healthImg, 
  educationImg, 
  agricultureImg, 
  logisticsImg, 
  legalImg,
  handymanImg,
  applianceImg,
  securityImg,
  tailoringImg,
  eventsImg
};
